module.exports = __webpack_public_path__ + "img/SPY.82a07222.svg";